export default __webpack_public_path__ + "static/media/women-player.a11d904a.jpg";